// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as Button$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as SuccessInfoComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/success/SuccessInfoComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

var customStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minWidth: "50%"
  }
};

function DeleteCampaignModal(Props) {
  var refreshView = Props.refreshView;
  var onToggle = Props.onToggle;
  var requestState = Props.requestState;
  var tmp;
  if (typeof requestState === "number") {
    tmp = React.createElement("div", undefined, "Sending the request for disabling campaign");
  } else {
    switch (requestState.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(LoadingViewComponent$Catalyst.make, {
                text: "Disabling campaign"
              });
          break;
      case /* Live */1 :
          tmp = React.createElement("div", undefined, React.createElement("h3", {
                    className: "header__h3 u-color-success"
                  }, "Success"), React.createElement(SuccessInfoComponent$Catalyst.make, {
                    message: "The campaign has been disabled"
                  }), React.createElement("div", {
                    className: "u-text-centre"
                  }, React.createElement(Button$Catalyst.make, {
                        text: "CLOSE",
                        cb: (function (_event) {
                            Curry._1(onToggle, undefined);
                            return Curry._1(refreshView, undefined);
                          }),
                        className: "driverModal__actionBtn"
                      })));
          break;
      case /* Error */2 :
          tmp = React.createElement("div", undefined, React.createElement("h3", {
                    className: "header__h3 u-color-error"
                  }, "Error"), React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: requestState._0
                  }), React.createElement("div", {
                    className: "u-text-centre"
                  }, React.createElement(Button$Catalyst.make, {
                        text: "CLOSE",
                        cb: (function (_event) {
                            Curry._1(onToggle, undefined);
                            return Curry._1(refreshView, undefined);
                          }),
                        className: "driverModal__actionBtn"
                      })));
          break;
      
    }
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(onToggle, undefined);
                }),
              style: customStyle,
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: null
            }, React.createElement("h2", {
                  className: "text-styling-header font-size-18 u-bottom-border u-padding-bottom-small"
                }, "Disable Campaign"), tmp);
}

var make = DeleteCampaignModal;

export {
  customStyle ,
  make ,
  
}
/* react Not a pure module */
